import React, { Component } from 'react'
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { Form, TextArea, Input, Icon, Button } from 'semantic-ui-react';
import Erro from "../layouts/mensagens/Erro";
import Validator from "validator";
import * as FormValidator from "../../utils/formValidator";
import InputMask from 'react-text-mask';
import { enviarEmailContato } from "../../actions/sistema";

const ASSUNTOS = ['Dúvida', 'Problema técnico', 'Pagamento', 'Sugestão'];
const LIMITE = 500;

class FormContato extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: {
        nome: "",
        email: "",
        telefone: "",
        mensagem: ""
      },
      assunto: ASSUNTOS[0],
      sucesso: false,
      loading: false,
      errors: {}
    }
  }

  componentDidMount() {
    const { usuario } = this.props;
    if (usuario) {
      this.setState(p => ({
        dados: { ...p.dados, nome: usuario.nome || '', email: usuario.email || '', telefone: usuario.celular || '' },
      }));
    }
  }

  onChange = e =>
    this.setState({
      dados: { ...this.state.dados, [e.target.name]: e.target.value },
      errors: {}
    });

  handleSubmit = async (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.dados);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      // o assunto segue junto da mensagem (a API recebe os mesmos campos de antes)
      await this.props.enviarEmailContato({
        ...this.state.dados,
        mensagem: `[${this.state.assunto}] ${this.state.dados.mensagem}`,
      });
      this.setState({
        loading: false,
        sucesso: FormValidator.objIsEmpty(this.props.errors),
        errors: this.props.errors
      });
    }
  };

  validate = dados => {
    const errors = {};
    if (FormValidator.isVazio(dados.nome)) errors.nome = "Nome é obrigatório";
    if (!Validator.isEmail(dados.email)) errors.email = "E-mail inválido";
    if (dados.telefone && !FormValidator.isNumeroCelular(dados.telefone)) errors.telefone = "Número inválido";
    if (FormValidator.isVazio(dados.mensagem) || dados.mensagem.length < 10 || dados.mensagem.length > LIMITE) errors.mensagem = "Sua mensagem precisa ter de 10 a 500 caracteres";
    return errors;
  };

  render() {
    const { dados, assunto, sucesso, loading, errors } = this.state;

    if (sucesso) {
      return (
        <div className="va-contato-card va-contato-sucesso">
          <div className="va-contato-ok"><Icon name="check" /></div>
          <h2>Mensagem enviada!</h2>
          <p>Recebemos o seu contato e responderemos no e-mail <b>{dados.email}</b>.</p>
          <Button as={Link} to="/" className="btn-ui-1" size="large">Voltar para o início</Button>
        </div>
      );
    }

    return (
      <div className="va-contato-card">
        <h2>Envie sua mensagem</h2>
        <Form onSubmit={this.handleSubmit} size="large">
          <div className="va-contato-assuntos" role="radiogroup" aria-label="Assunto">
            {ASSUNTOS.map(item => (
              <button
                type="button"
                key={item}
                role="radio"
                aria-checked={assunto === item}
                className={assunto === item ? 'ativo' : ''}
                onClick={() => this.setState({ assunto: item })}
              >
                {item}
              </button>
            ))}
          </div>

          <Form.Group widths="equal">
            <Form.Field error={!!errors.nome}>
              <label htmlFor="nome">Nome</label>
              <Input id="nome" type="text" name="nome" placeholder="Seu nome" value={dados.nome} onChange={this.onChange} />
              <Erro text={errors.nome} />
            </Form.Field>
            <Form.Field error={!!errors.telefone}>
              <label htmlFor="telefone">Celular <small>(opcional)</small></label>
              <InputMask
                type="text"
                id="telefone"
                name="telefone"
                placeholder="(ddd) número"
                mask={['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                guide={true}
                value={dados.telefone}
                onChange={this.onChange}
              />
              <Erro text={errors.telefone} />
            </Form.Field>
          </Form.Group>

          <Form.Field error={!!errors.email}>
            <label htmlFor="email">E-mail para resposta</label>
            <Input id="email" type="email" name="email" placeholder="voce@exemplo.com.br" value={dados.email} onChange={this.onChange} />
            <Erro text={errors.email} />
          </Form.Field>

          <Form.Field error={!!errors.mensagem}>
            <label htmlFor="mensagem">Mensagem</label>
            <TextArea
              id="mensagem"
              name="mensagem"
              placeholder="Descreva com o máximo de detalhes possível..."
              rows={5}
              value={dados.mensagem}
              onChange={this.onChange}
              style={{ minHeight: 140, maxHeight: 260 }}
            />
            <div className={`va-contato-contador ${dados.mensagem.length > LIMITE ? 'excedeu' : ''}`}>
              {dados.mensagem.length}/{LIMITE}
            </div>
            <Erro text={errors.mensagem} />
          </Form.Field>

          <Button className="btn-ui-1" fluid loading={loading} disabled={loading} size="large">
            <Icon name="send" /> Enviar mensagem
          </Button>

          {!!errors.global &&
            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <Erro text={errors.global} style={{ fontSize: "1.1em" }} />
            </div>
          }
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errors: state.sistema.errors,
    usuario: state.user && state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    enviarEmailContato,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContato);
